module.exports = __webpack_public_path__ + "img/infographicWhatWeDoHorizontal.9c2bdbae.png";